const NOTE_CREATE_FAILED = 'NOTE_CREATE_FAILED';
const NOTE_CREATE_RECEIVED = 'NOTE_CREATE_RECEIVED';
const NOTE_CREATE_REQUESTED = 'NOTE_CREATE_REQUESTED';
const NOTE_EDIT_FAILED = 'NOTE_EDIT_FAILED';
const NOTE_EDIT_RECEIVED = 'NOTE_EDIT_RECEIVED';
const NOTE_EDIT_REQUESTED = 'NOTE_EDIT_REQUESTED';
const NOTES_FAILED = 'NOTES_FAILED';
const NOTES_RECEIVED = 'NOTES_RECEIVED';
const NOTES_REQUESTED = 'NOTES_REQUESTED';
const NOTES_LOADING = 'NOTES_LOADING';
const SET_NOTE_TO_EDIT = 'SET_NOTE_TO_EDIT';

const initialState = {
  ui: {
    noteCreateLoading: false,
    noteCreateFailed: false,
    noteEditLoading: false,
    notesLoadingError: false,
    noteCreateError: false,
    noteEditError: false,
    loginStarted: false,
    loginSuccess: false,
    loginFail: false,
    noteCreateModalOpen: false,
    noteEditModalOpen: false,
    notesLoading: false,
  },
  data: {
    notes: [],
    userID: '',
    noteToEdit: {
      content: '',
    },
  },
};

/**
 * Notes action ladder
 *
 * @param {object} state=initialState
 * @param {object} action
 * @returns {{notes, newStateParam: *}|{notes: []}|{notes: *}}
 */
const notes = (state = initialState, action) => {
  switch (action.type) {
    case NOTES_REQUESTED:
      return {
        ...state,
        ui: { ...state.ui, notesLoading: action.payload },
        data: { ...state.data },
      };
    case NOTES_RECEIVED:
      return {
        ...state,
        ui: { ...state.ui },
        data: { ...state.data, notes: action.payload },
      };
    case NOTES_FAILED:
      return {
        ...state,
        ui: { ...state.ui, notesLoadingError: action.payload },
        data: { ...state.data },
      };
    case NOTE_CREATE_REQUESTED:
      return {
        ...state,
        ui: { ...state.ui, noteCreateLoading: action.payload },
        data: { ...state.data },
      };
    case NOTE_CREATE_RECEIVED:
      return state;
    case NOTE_CREATE_FAILED:
      return {
        ...state,
        ui: { ...state.ui, noteCreateError: action.payload },
        data: { ...state.data },
      };
    case NOTE_EDIT_REQUESTED:
      return {
        ...state,
        ui: { ...state.ui, noteEditLoading: action.payload },
        data: { ...state.data },
      };
    case NOTE_EDIT_RECEIVED:
      return state;
    case NOTE_EDIT_FAILED:
      return {
        ...state,
        ui: { ...state.ui, noteEditError: action.payload },
        data: { ...state.data },
      };
    case NOTES_LOADING:
      return {
        ...state,
        ui: { ...state.ui, notesLoading: action.payload },
        data: { ...state.data },
      };
    case SET_NOTE_TO_EDIT:
      return {
        ...state,
        ui: { ...state.ui },
        data: { ...state.data, noteToEdit: action.payload },
      };

    default:
      return state;
  }
};

export default notes;
